























































import { Vue, Component, Prop } from 'vue-property-decorator';
import { SupplierEntry } from '~/types/Supplier';
import { SupplierReviewEntry } from '~/types/SupplierReview';
import { HasImage } from '~/interfaces/image';
import { averageOfAllReviews } from '~/helpers/reviews';
import { getPathForEntry } from '~/helpers/routes';
import { getImage } from '~/helpers/image';
import RichTextRenderer from '~/patterns/molecules/rich-text/rich-text.vue';
import GhLink from '~/patterns/atoms/link/link.vue';
import CloudinaryImage from '~/patterns/atoms/cloudinary-image/cloudinary-image.vue';
import Stars from '~/patterns/atoms/stars.vue';
import SolutionIcon from '~/patterns/atoms/solution-icon.vue';

@Component({
    components: { RichTextRenderer, GhLink, CloudinaryImage, Stars, SolutionIcon },
    methods: {
        getPathForEntry
    }
})
export default class CardSupplier extends Vue {
    @Prop() item!: SupplierEntry;

    @Prop() readonly name!: string;

    @Prop() readonly logo!: string;

    @Prop() readonly distance!: number;

    @Prop() readonly reviews: SupplierReviewEntry[];

    get averageReviewScore() {
        return this.item.fields.averageRating || Math.round(averageOfAllReviews(this.reviews));
    }

    get productOptionsString() {
        if (Array.isArray(this.item.fields.productOptions)) {
            return this.item.fields.productOptions.map(option => option?.fields?.name).join(', ');
        }
        return undefined;
    }

    get certificatesString() {
        if (Array.isArray(this.item.fields.supplierCertificates)) {
            return this.item.fields.supplierCertificates.map(certificate => certificate?.fields?.name).join(', ');
        }
        return undefined;
    }

    get averageRating() {
        return this.item.fields.averageRating && this.item.fields.averageRating > 0
            ? this.item.fields.averageRating
            : 0;
    }

    get distanceFromUser() {
        return this.item?.fields?.nearestLocation?.distance.toFixed(1);
    }

    get image(): HasImage {
        return getImage(this.item.fields, 'image', 'companyLogo');
    }
}
